<template>
  <base-modal
    id="ImportClientsModal"
    :size="useFeature('customer_external_id_only') ? 'modal-sm' : 'modal-lg'"
    expanded
    :show="show"
    @closed="show = false"
  >
    <!-- Important note!
    There is no FIGMA with this usercase (Modal + Tabs at right side)
    That's why it looks a little bit off.
    -->
    <base-tabs
      v-if="tabs.length > 1"
      v-model="currentTab"
      :items="tabs"
      class="pr-5"
      underlined
    />
    <div
      v-if="show"
      :class="{'mt--5': tabs.length > 1}"
    >
      <add-client-container
        v-if="currentTab == 0"
        @success="close"
        @closeModal="close"
      />
      <template v-if="currentTab == 1">
        <import-client-list />
        <upload-file class="mt-4" />
      </template>
    </div>
  </base-modal>
</template>

<script>
import utilsMixin from '@/_utilities/utilsMixin';
import ImportClientList from './ImportClients/ImportClientList';
import AddClientContainer from './ImportClients/AddClientContainer';
import UploadFile from './ImportClients/UploadFile';

export default {
  name: 'ImportClientsModal',
  components: {
    ImportClientList,
    AddClientContainer,
    UploadFile,
  },
  mixins: [utilsMixin],
  props: {
    canUpload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentTab: 0,
      show: false,
    };
  },
  computed: {
    tabs() {
      const tabs = ['Add Clients'];
      if (this.canUpload) {
        tabs.push('Upload Clients');
      }
      return tabs;
    },
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog{
  & .modal-body {
    padding: 27px 23px 28px 24px;
  }
}
// ::v-deep .close {
  // padding: 35px 25px 0 0 !important;

  // & .base-icon {
  //   width: 18px !important;
  //   fill: black !important;
  //   transform: translateY(-25%); /* This is to vertically center the icon */
  // }
// }
@media (max-width: map-get($breakpoints,'lg')) {
  ::v-deep .modal-dialog{
    margin:auto;
    & .modal-body {
      padding: 24px;
    }
  }
  // ::v-deep .close {
  //   padding: 24px 24px 0 0 !important;
  // }
}
</style>
